export default __webpack_public_path__ + "static/media/mail.4fb99957.svg";